const pendingRequests = new Map<string, Promise<any>>();

function generateRequestKey(url: string, options?: RequestInit): string {
  const method = options?.method || 'GET';
  const body = options?.body ? String(options.body).substring(0, 200) : '';
  return `${method}:${url}:${body}`;
}

export function getPendingRequest(key: string): Promise<any> | undefined {
  return pendingRequests.get(key);
}

export function setPendingRequest(key: string, promise: Promise<any>): void {
  pendingRequests.set(key, promise);
  // 🔴 清理链先接 catch：.finally 的派生 promise 会继承原 rejection，
  // 无人处理时任何失败的去重 GET（401/5xx/网络异常）都会产生
  // unhandled rejection。原 promise 的错误仍由真实调用方 await 处理，
  // 此处仅负责清理 Map。
  promise.catch(() => {}).finally(() => pendingRequests.delete(key));
}

export function makeRequestKey(url: string, options?: RequestInit): string {
  return generateRequestKey(url, options);
}

export function isGetRequest(options?: RequestInit): boolean {
  return !options?.method || options.method === 'GET';
}
